import React from 'react';
import { useI18n } from '../../hooks/useI18n';
import { classNames } from '../../utils/classNames';

export const ChatMessageImages = ({ urls = [], onPreview, className, compact = false }) => {
  const { t } = useI18n();

  if (!urls.length) {
    return null;
  }

  return (
    <div className={classNames('flex flex-wrap gap-1.5', className)}>
      {urls.map((url, index) => (
        <button
          key={`${url}-${index}`}
          type="button"
          onClick={() => onPreview?.(url)}
          className="group relative overflow-hidden rounded-lg border border-white/25 bg-black/10 transition hover:ring-2 hover:ring-white/40 dark:border-border/70 dark:bg-slate-900/40 dark:hover:ring-accent/40"
          aria-label={t('chatMessageImageOpen')}
        >
          <img
            src={url}
            alt={t('chatAttachmentPreviewAlt')}
            className={classNames('object-cover', compact ? 'h-14 w-14' : 'h-16 w-16')}
            loading="lazy"
          />
        </button>
      ))}
    </div>
  );
};
